<template>
  <main-layout>
    <div>
      <exclamation-circle
        scale="3"
        color="red"
      />
    </div>
    <div>
      <p>
        {{ $t('recurrence.cancel.text', { msisdn, card }) }}
      </p>
      <p>
        {{ $t('recurrence.cancel.instruction') }}
      </p>
    </div>
    <p v-show="isError">
      {{ isError }}
    </p>
    <button
      id="cancelRecurrence"
      class="button"
      @click="cancelRecurrence"
    >
      Confirmar
    </button>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import MainLayout from '@/components/MainLayout';
import { ExclamationCircle } from '@/components/icons';
import { getToken, setToken } from '@/utils/token';
import phoneFormatter from '@/utils/phoneFormatter';

export default {
  name: 'CancelRecurrenceConfirmation',
  components: { ExclamationCircle, MainLayout },
  data() {
    return {
      isLoading: false,
      isError: ''
    };
  },
  computed: {
    ...mapGetters(['country']),
    msisdn() {
      return phoneFormatter(getToken().msisdn) || 'XXXXXX';
    },
    card() {
      return this.$route.query.last4Digits || 'XXXX';
    }
  },
  created() {
    this.updateToken();
  },
  methods: {
    cancelRecurrence() {
      this.isLoading = true;

      global.api
        .mpcCancelRecurrence()
        .then(() => {
          this.$emit('confirm');
        })
        .catch(() => {
          this.$router.push({
            name: 'Error',
            query: { error: 'GENERIC_ERROR' }
          });
        }).finally(() => { this.isLoading = false; });
    },
    updateToken() {
      setToken('tokenIvr', this.$route.query.t);
    }

  }
};
</script>
